import MyDealCard from './MyDealCard';
export default MyDealCard;
